import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { FooterButton } from 'Core/components';
import { actions as overheadCraneActions, addOverheadCrane } from './store/slice';
import { showToast } from 'Core/redux/toast/slice';

const { setOverheadCrane } = overheadCraneActions;

const initData = {
  id: 0,
  userId: '',
  assetNumber: '',
  cellNumber: '',
  brand: '',
  modelNumber: '',
  tonnage: '',
  shotsize: '',
  tieBarDistanceH: '',
  tieBarDistanceV: '',
  moldheightMin: '',
  moldheightMax: '',
  serialNumber: '',
  numberofCores: '',
  numberofValveGates: '',
  numberofAirBlows: '',
  changed: '',
  isDeleted: '',
  lane: 'L-1',
  orientation: '0',
};

const saveKeys = ['changed', 'id', 'isDeleted', 'userId'];
const editKeys = ['changed', 'isDeleted'];

const OverheadCraneAddEditModal = () => {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState(initData);
  const dispatch = useDispatch();

  const handleClose = () => {
    setShow(false);
    setFormData(initData);
  };

  const handleShow = () => setShow(true);

  const updateFormField = (fieldName, value) => {
    setFormData(prevData => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  const orientationOptions = [
    { value: 0, label: 'Select Orientation' },
    { value: 1, label: 'Horizontal' },
    { value: 2, label: 'Vertical' },
  ];

  const isEditMode = Boolean(formData?.id);

  const valid = () => {
    const ignoreKeys = isEditMode ? editKeys : saveKeys;
    if (
      !formData ||
      Object.keys(formData).some(key => {
        return !ignoreKeys.includes(key) && !formData[key];
      })
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  const onSave = () => {
    if (valid()) {
      const payload = {
        ...formData,
        userId: localStorage.getItem('UserId'),
      };
      console.log('Saving Overhead Crane:', payload);
      
      dispatch(addOverheadCrane(payload))
        .unwrap()
        .then(() => {
          dispatch(
            showToast({
              message: 'Overhead Crane added successfully!',
              type: 'success',
            }),
          );
          handleClose();
        })
        .catch((error) => {
          dispatch(
            showToast({
              message: error || 'Failed to add Overhead Crane',
              type: 'danger',
            }),
          );
        });
    }
  };

  // Global function to show modal
  React.useEffect(() => {
    const handleShowModal = () => handleShow();
    window.addEventListener('showOverheadCraneModal', handleShowModal);
    window.showOverheadCraneModal = handleShowModal;
    
    return () => {
      window.removeEventListener('showOverheadCraneModal', handleShowModal);
      delete window.showOverheadCraneModal;
    };
  }, []);

  return (
    <>
      <Modal show={show} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Add Overhead Crane</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Asset Number <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    name="assetNumber"
                    type="text"
                    className="form-control"
                    value={formData.assetNumber}
                    onChange={e => updateFormField('assetNumber', e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Cell Number <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    type="text"
                    value={formData.cellNumber}
                    onChange={e => updateFormField('cellNumber', e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Brand <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    type="text"
                    value={formData.brand}
                    onChange={e => updateFormField('brand', e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Model Number <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    type="text"
                    value={formData.modelNumber}
                    onChange={e => updateFormField('modelNumber', e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Tonnage <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    type="text"
                    value={formData.tonnage}
                    onChange={e => updateFormField('tonnage', e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Shot Size (oz) <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    type="text"
                    value={formData.shotsize}
                    onChange={e => updateFormField('shotsize', e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Tie Bar Distance (Horizontal) <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    type="text"
                    value={formData.tieBarDistanceH}
                    onChange={e => updateFormField('tieBarDistanceH', e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Tie Bar Distance (Vertical) <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    type="text"
                    value={formData.tieBarDistanceV}
                    onChange={e => updateFormField('tieBarDistanceV', e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Mold Height Minimum <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    type="text"
                    value={formData.moldheightMin}
                    onChange={e => updateFormField('moldheightMin', e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Mold Height Maximum <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    type="text"
                    value={formData.moldheightMax}
                    onChange={e => updateFormField('moldheightMax', e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Serial Number <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    type="text"
                    value={formData.serialNumber}
                    onChange={e => updateFormField('serialNumber', e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Number of Cores <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    type="text"
                    value={formData.numberofCores}
                    onChange={e => updateFormField('numberofCores', e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Number of Valve Gates <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    type="text"
                    value={formData.numberofValveGates}
                    onChange={e => updateFormField('numberofValveGates', e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Number of Air Blows <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    type="text"
                    value={formData.numberofAirBlows}
                    onChange={e => updateFormField('numberofAirBlows', e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Lane <span className="text-danger">*</span>
                </label>
                <div className="input-groupicon calender-input">
                  <input
                    type="text"
                    value={formData.lane}
                    onChange={e => updateFormField('lane', e.target.value)}
                    className="form-control"
                    readOnly
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Orientation
                </label>
                <select
                  value={formData.orientation}
                  onChange={e => updateFormField('orientation', e.target.value)}
                  className="form-control"
                >
                  {orientationOptions.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-lg-8"></div>
            <div className="col-12 col-lg-4">
              <FooterButton
                cancelText="Cancel"
                saveText="Save Overhead Crane"
                onSave={onSave}
                onCancel={handleClose}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default OverheadCraneAddEditModal;
